import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/copyTexture3DLayerToTexture.fragment.js
var name, shader, copyTexture3DLayerToTexturePixelShader;
var init_copyTexture3DLayerToTexture_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/copyTexture3DLayerToTexture.fragment.js"() {
    init_shaderStore();
    name = "copyTexture3DLayerToTexturePixelShader";
    shader = `precision highp sampler3D;uniform sampler3D textureSampler;uniform int layerNum;varying vec2 vUV;void main(void) {vec3 coord=vec3(0.0,0.0,float(layerNum));coord.xy=vec2(vUV.x,vUV.y)*vec2(textureSize(textureSampler,0).xy);vec3 color=texelFetch(textureSampler,ivec3(coord),0).rgb;gl_FragColor=vec4(color,1);}
`;
    ShaderStore.ShadersStore[name] = shader;
    copyTexture3DLayerToTexturePixelShader = { name, shader };
  }
});

export {
  copyTexture3DLayerToTexturePixelShader,
  init_copyTexture3DLayerToTexture_fragment
};
